import { Stack } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  nameBlock: ReactNode;
  editorBlock: ReactNode;
  adminBlock: ReactNode;
  menuBlock: ReactNode;
  withBg: boolean;
};
export const SharedUserRow = ({
  nameBlock,
  editorBlock,
  adminBlock,
  menuBlock,
  withBg,
}: Props) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        gap: "24px",
        alignItems: "center",
        padding: "4px 16px",
        borderRadius: "6px",
        backgroundColor: withBg ? "#F7F7F7" : undefined,
      }}
    >
      <Stack justifyContent="center" alignItems="flex-start" width="100%">
        {nameBlock}
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="center"
        minWidth="42px"
        width="42px"
      >
        {editorBlock}
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="center"
        minWidth="44px"
        width="44px"
      >
        {adminBlock}
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="center"
        minWidth="16px"
        width="16px"
      >
        {menuBlock}
      </Stack>
    </Stack>
  );
};
